import { zodResolver } from '@hookform/resolvers/zod'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { z } from 'zod'

const schema = z.object({
  name: z.string(),
  tableCode: z.string(),
  percents: z.string(),
  bonus: z.string().optional(),
  leaderCommission: z.string().optional(),
})

export type SelectedTab = 'partners' | 'banner' | 'configs' | 'table'

export type FormCreateTableData = z.infer<typeof schema>

export const useConfiguracoesController = () => {
  const [selectedTab, setSelectedTab] = useState<SelectedTab>('partners')

  const methods = useForm<FormCreateTableData>({
    resolver: zodResolver(schema),
  })

  return {
    selectedTab,
    setSelectedTab,
    methods,
  }
}
